export class EmailValidator {
    static EMAIL_PATTERN = /^[_A-Za-z0-9-\\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;

    static isValid(email) {
        if (email === null || email.trim() === '') {
            return false;
        }
        return EmailValidator.EMAIL_PATTERN.test(email);
    }
}